module.exports = __webpack_public_path__ + "img/welfare_title_banner.547ba612.png";